import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { resolvePageMeta } from '../../services/pageMeta';
import { trackPageView } from '../../services/analytics';

export const RouteAnalytics: React.FC = () => {
  const { pathname } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    // StrictMode double-invokes effects in dev; without this guard the first
    // page view of every route fires twice.
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;

    const { title, pageType, toolId } = resolvePageMeta(pathname);
    // Nothing else in the app sets document.title -- titles are baked per route
    // at build time by scripts/prerender.mjs, so without this the tab label (and
    // the reported page_title) keeps the entry page's value forever.
    document.title = title;
    trackPageView(pathname, title, pageType, toolId);
  }, [pathname]);

  return null;
};
